export const determineReferredMarketCode = (opts) => {
	const { cookieMarketCode, isFromSearch, isReferred, marketCode } = opts;

	const isValid = isReferred || isFromSearch;
	const referredMarketCode = cookieMarketCode || marketCode;

	return isValid ? referredMarketCode : null;
};

// This is the slugify logic from search API in the isPermitted resolver
// If our parsed city doesn't slugify to a valid slug, the given location slug is invalid
// https://github.com/tkww/marketplace-search-api/blob/9f660878c0526696dd49e762acb7e039b97190d7/src/helpers/slugify.js
export const validateCitySlug = (city = '') =>
	city
		.replace(/[~!@#$%^*(){}[\];:"<,.>?/\\|+=]/g, '')
		.replace(/\s+/g, '-')
		.toLowerCase();
